export const GET_VAULT_TRANSACTIONS = "GET_VAULT_TRANSACTIONS";
export const GET_VAULT_TRANSACTION_RECIPIENTS = "GET_VAULT_TRANSACTION_RECIPIENTS";
export const REVOKE_VAULT_TRANSACTION = "REVOKE_VAULT_TRANSACTION";
